import { SvgIcon, SvgIconProps } from '@mui/material';

function EyeClosedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.7994 11.7507L21.4575 11.3909L20.7994 11.7507ZM20.7994 13.3197L21.4574 13.6796L20.7994 13.3197ZM3.20058 11.7506L3.8586 12.1105L3.20058 11.7506ZM3.20057 13.3196L2.54254 13.6794H2.54254L3.20057 13.3196ZM19.5236 8.84422C19.227 8.55505 18.7522 8.56105 18.463 8.85762C18.1738 9.15419 18.1798 9.62903 18.4764 9.9182L19.5236 8.84422ZM9.68628 17.4948C9.28505 17.3919 8.87638 17.6338 8.7735 18.035C8.67062 18.4362 8.91249 18.8449 9.31372 18.9478L9.68628 17.4948ZM14.604 6.8763L14.4099 7.60074L14.604 6.8763ZM7.07264 17.244L6.70374 17.897L7.50475 16.631L7.07264 17.244ZM3.8586 12.1105C5.43153 9.23434 8.4879 7.28516 12 7.28516V5.78516C7.91882 5.78516 4.36847 8.05202 2.54256 11.3907L3.8586 12.1105ZM20.1414 12.9599C18.5685 15.836 15.5121 17.7852 12 17.7852V19.2852C16.0812 19.2852 19.6315 17.0183 21.4574 13.6796L20.1414 12.9599ZM20.1414 12.1106C20.2862 12.3754 20.2862 12.6951 20.1414 12.9599L21.4574 13.6796C21.8475 12.9663 21.8475 12.1041 21.4575 11.3909L20.1414 12.1106ZM2.54256 11.3907C2.15249 12.104 2.15248 12.9662 2.54254 13.6794L3.8586 12.9597C3.7138 12.6949 3.7138 12.3752 3.8586 12.1105L2.54256 11.3907ZM18.4764 9.9182C19.1347 10.56 19.6974 11.2986 20.1414 12.1106L21.4575 11.3909C20.9413 10.4469 20.2876 9.58919 19.5236 8.84422L18.4764 9.9182ZM12 17.7852C11.2002 17.7852 10.4251 17.6842 9.68628 17.4948L9.31372 18.9478C10.1732 19.1682 11.0735 19.2852 12 19.2852V17.7852ZM12 7.28516C12.8346 7.28516 13.6423 7.39506 14.4099 7.60074L14.7981 6.15185C13.905 5.91255 12.9668 5.78516 12 5.78516V7.28516ZM5.92995 15.5255C5.09529 14.8029 4.39151 13.9342 3.8586 12.9597L2.54254 13.6794C3.16202 14.8122 3.97944 15.8209 4.94816 16.6596L5.92995 15.5255ZM7.44154 16.591C6.90181 16.2861 6.3956 15.9287 5.92995 15.5255L4.94816 16.6596C5.48873 17.1276 6.07659 17.5428 6.70374 17.897L7.44154 16.591ZM5.00695 16.7056L6.64054 17.8571L7.50475 16.631L5.87116 15.4795L5.00695 16.7056ZM14.4099 7.60074C15.1269 7.79286 15.8096 8.06874 16.4471 8.41734L17.1668 7.1013C16.426 6.69615 15.6321 6.37531 14.7981 6.15185L14.4099 7.60074Z"
          fill="#4C4C58"
        />
        <path
          d="M19.4645 5L4.46448 20"
          stroke="#4C4C58"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12.5352C9 10.8783 10.3431 9.53516 12 9.53516"
          stroke="#4C4C58"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </SvgIcon>
  );
}

export default EyeClosedIcon;
